import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import baseUrl from "../Constant";
import { useNavigate } from 'react-router-dom';
import Login from "./Login";

const AppContext = createContext();

const AppProvider = ({ children }) => {
    const [isLoggedIn, setLoggedIn] = useState(false);
    const [message, setMessage] = useState("");
    const [color, setColor] = useState("");
    const navigate = useNavigate()

    const token = localStorage.getItem("token")
    console.log("context token", token)

    useEffect(()=>{
         if (token) {
        setLoggedIn(true)
     } else {
         setLoggedIn(false)
     }
    },[])

    function login(email, password) {
        axios.post(`${baseUrl}/accounts/drlogin`, { email, password })
            .then((res) => {
                console.log(res.data)
                setMessage(res.data.message);
                if (res.data.status === 200) {
                    localStorage.setItem('token', JSON.stringify(res.data.access));
                    setLoggedIn(true);
                    setMessage('')
                    navigate("/dashboard")
                } else {
                    setColor("red")
                    setTimeout(() => {
                        setMessage('')
                        setColor("");
                    }, 2000);
                };

            })
            .catch((error) => {
                console.log(error)
            })
    }



    const logout = () => {
        localStorage.removeItem("token");
        navigate("/login")
        setLoggedIn(false);

    };

    const contextValues = {
        isLoggedIn,
        login,
        logout,
        message,
        color
    };

    return (
        <AppContext.Provider value={contextValues}>
            {children}
        </AppContext.Provider>
    )
};

const useGlobalContext = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useGlobalContext must be used within an AppProvider');
    }
    return context;
};

export {AppProvider, useGlobalContext };

